import Twitter from '../../src/legacy/Twitter';
export default Twitter;
